import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-monthly-reports',
  templateUrl: './monthly-reports.component.html',
  styleUrls: ['./monthly-reports.component.scss']
})
export class MonthlyReportsComponent implements OnInit {

  title = 'Monthly Reports';

  constructor(private router:Router, private titleService: Title) {
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
  }

  onMonthlyReportClick(reportCode: string, reportName: string)
  {
    sessionStorage.setItem('reportCode', reportCode );
    sessionStorage.setItem('reportName', reportName );

    const reportType = 'Monthly Report';

    this.router.navigate(['/monthlyReportCreiteria'], {queryParams:{
      reportType:reportType
    }});

  }

}
